import axios from 'axios';
import { getNonGwApiRoot } from '../../constants/ParamountReactConstants';
import { CustomAppConfigRequest, CustomAppLevel } from '../../../types/customApps';

export function fetchCustomAppConfigs(level?: CustomAppLevel, entityId?: number) {
  let url = `${getNonGwApiRoot()}/actions/custom-apps/configs`;
  const params = new URLSearchParams();

  if (level) {
    params.append('level', level);
  }
  if (entityId !== undefined) {
    params.append('entity_id', entityId.toString());
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return {
    type: 'FETCH_CUSTOM_APP_CONFIGS',
    payload: axios.get(url),
  };
}

export function createCustomAppConfig(config: CustomAppConfigRequest) {
  return {
    type: 'CREATE_CUSTOM_APP_CONFIG',
    payload: axios.post(`${getNonGwApiRoot()}/actions/custom-apps/configs`, config),
  };
}

export function updateCustomAppConfig(configId: number, config: Partial<CustomAppConfigRequest>) {
  return {
    type: 'UPDATE_CUSTOM_APP_CONFIG',
    payload: axios.put(`${getNonGwApiRoot()}/actions/custom-apps/configs/${configId}`, config),
  };
}

export function deleteCustomAppConfig(configId: number) {
  return {
    type: 'DELETE_CUSTOM_APP_CONFIG',
    payload: axios.delete(`${getNonGwApiRoot()}/actions/custom-apps/configs/${configId}`),
    meta: { configId },
  };
}
